module.exports = __webpack_public_path__ + "static/p08_lodoCerditoTop-8dc49945dc885891c244cf890b73a307.png";